<div
  [attr.data-tooltip]="trialRequested ? text.confirmation_info(created, email) : ''"
  [ngClass]="{'tooltip--right': trialRequested}">
  <button
    type="button"
    [disabled]="trialRequested"
    class="Button--secondary Button--medium Button"
    (click)="openTrialModal()"
  >
    {{ text.button_trial }}
  </button>
</div>
